import React from "react";
import { useT } from "@/lib/i18n";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useT();
  const next = lang === "en" ? "es" : "en";
  return (
    <button
      type="button"
      onClick={() => setLang(next)}
      data-testid="language-toggle"
      aria-label={`Switch to ${next === "es" ? "Spanish" : "English"}`}
      className={`inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white/80 backdrop-blur px-3 h-9 text-xs font-bold tracking-wider text-slate-600 hover:text-brand-navy hover:border-brand-blue transition-colors ${className}`}
    >
      <span className={lang === "en" ? "text-brand-blue" : ""}>EN</span>
      <span className="mx-0.5 text-slate-300">/</span>
      <span className={lang === "es" ? "text-brand-blue" : ""}>ES</span>
    </button>
  );
}
